import _ from "lodash";
import axios from "axios";
import {
  http
} from '../utils/http';
import moment from 'moment';

const queryConfig = (configs, field, targetConfig) => {
  for (let index = 0; index < configs.length; index++) {
    if (configs[index].field == field) {
      return targetConfig.push(configs[index]);
    } else if (
      _.isArray(configs[index].contents) &&
      configs[index].contents.length > 0
    ) {
      queryConfig(configs[index].contents, field, targetConfig);
    }
  }
};

const queryValueByConfig = (config, field) => {
  if (_.isArray(config.contents)) {
    for (let index = 0; index < config.contents.length; index++) {
      if (config.contents[index].field === field) {
        return config.contents[index].instance.params[field];
      }
    }
  }
  if (_.isObject(config)) {
    if (config.field === field) {
      return config.instance.params[field];
    } else if (config.instance.$parent) {
      return queryValueByConfig(config.instance.$parent, field);
    }
  }
};

export default class LayoutConfig {

  static setAllParams(allParams) {
    LayoutConfig.allParams = allParams;
  }

  static setSameLevelParams(params) {
    LayoutConfig.params = params;
  }

  static dispfetchByConfig(vm, layoutConfigs, config, params = {}, depends = {}) {
    return LayoutConfig.promiseDelay()
      .then(() => {
        return LayoutConfig.getDependsByConfig(vm, layoutConfigs, config, depends);
      })
      .then(() => {
        let canRequest = true; //校验依赖的参数是否是必填项,校验通过才可请求
        if (config.fetch.depends) {
          Object.keys(config.fetch.depends).forEach(key => {
            if (config.fetch.depends[key].isRequired) {
              canRequest = depends[key] ? true : false;
            }
          });
        }
        if (!canRequest) {
          return;
        }
        return http.get(config.fetch.url, {
          params: {
            ...config.fetch.params,
            ...depends,
            ...params
          },
        });
      });
  }

  static getConfigByField(layoutConfigs, field) {
    const targetConfig = [];
    queryConfig(layoutConfigs, field, targetConfig);
    return targetConfig[0];
  }

  // 查找依赖config上的依赖值
  static getDependsByConfig(vm, layoutConfigs, config, depends = {}) {
    if (config.fetch && config.fetch.depends) {
      _.forIn(config.fetch.depends, (val) => {
        const dependParam = Object.keys(val)[0];
        let dependParamValue = _.cloneDeep(LayoutConfig.allParams);
        if (val[dependParam].from === 'superior') {
          let fields = val[dependParam].fieldPath.split('.');
          fields.forEach(field => {
            dependParamValue = dependParamValue[field];
          });
        } else if (val[dependParam].from === 'same') {
          const dependConfig = vm.formConfig.contents.find(item => item.field === dependParam)
          if (dependConfig.type === 'text') {
            dependParamValue = vm.formParamsInit[dependParam];
          } else {
            dependParamValue = vm.params[dependParam];
          }
        };
        depends[dependParam] = dependParamValue;
      });
    }
    return depends;
  }

  static promiseDelay(delay = 0) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, delay);
    });
  }

  static isNomalDate(selectedDate, compare) {
    if (!selectedDate || !compare) return true;
    let res = true;
    if ((compare.type === 'day' || compare.type === 'month') && !compare.limit_day) {
      const before_deadline = moment()
        .startOf('day')
        .add(compare.number, compare.type);
      if (selectedDate.startOf('day').diff(before_deadline) < 0) {
        res = false;
      }
    } else if (compare.limit_day) {

      let deadLine = moment().set('month', moment().month() + compare.number);
      deadLine = moment(deadLine).date(compare.limit_day).startOf('day');

      if (selectedDate.startOf('day').diff(deadLine) < 0) {
        res = false;
      }
    }
    return res;
  }
}